module.exports = __webpack_public_path__ + "assets/facebook.079f6725.svg";